
        
    const runtime = require("../../../../../../../../node_modules/simple-nunjucks-loader/lib/cjs/runtime.js");
    
    const __nunjucks_module_dependencies__ = {};
    
        
        
        const __nunjucks_template_import__dep_0 = require("./-question-help.html");
        
        const __nunjucks_template_import__dep_1 = require("../../../../lib/uniform/views/templates/uniform-macros.html");
        
    __nunjucks_module_dependencies__.templates = {...__nunjucks_template_import__dep_0.__nunjucks_module_dependencies__.templates,
...__nunjucks_template_import__dep_1.__nunjucks_module_dependencies__.templates};
    __nunjucks_module_dependencies__.globals = {...__nunjucks_template_import__dep_0.__nunjucks_module_dependencies__.globals,
...__nunjucks_template_import__dep_1.__nunjucks_module_dependencies__.globals};
    __nunjucks_module_dependencies__.extensions = {...__nunjucks_template_import__dep_0.__nunjucks_module_dependencies__.extensions,
...__nunjucks_template_import__dep_1.__nunjucks_module_dependencies__.extensions};
    __nunjucks_module_dependencies__.filters = {...__nunjucks_template_import__dep_0.__nunjucks_module_dependencies__.filters,
...__nunjucks_template_import__dep_1.__nunjucks_module_dependencies__.filters};
    __nunjucks_module_dependencies__.assets = {...__nunjucks_template_import__dep_0.__nunjucks_module_dependencies__.assets,
...__nunjucks_template_import__dep_1.__nunjucks_module_dependencies__.assets};
    
    
    
    
    
    
        
            __nunjucks_module_dependencies__.templates["assessments/admin/views/templates/multiple-choice-question.html"] = (function() {
                function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("lib/uniform/views/templates/uniform-macros.html", false, "assessments/admin/views/templates/multiple-choice-question.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("form", t_1);
output += "\n\n<div class=\"pw-uniform-table no-border\">\n  <div data-row-span=\"1\">\n    <div data-field-span=\"1\">\n      ";
output += runtime.suppressValue((lineno = 5, colno = 16, runtime.callWrap(runtime.memberLookup((t_1),"text"), "form[\"text\"]", context, ["title",{"required": true},{"nowrap": true,"bind": "model:title","class": "full-width","label": "Question","placeholder": "Enter\n      your question..."}])), env.opts.autoescape);
output += "\n    </div>\n  </div>\n\n  <div data-row-span=\"1\">\n    <div data-field-span=\"1\">\n      ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("assessments/admin/views/templates/-question-help.html", false, "assessments/admin/views/templates/multiple-choice-question.html", null, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
callback(null,t_4);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
callback(null,t_5);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n    </div>\n  </div>\n\n  <div data-row-span=\"1\">\n    <div data-field-span=\"1\">\n      <label>Answer Options</label>\n      <ul class=\"multiple-choice-options\"></ul>\n    </div>\n  </div>\n\n  <div data-row-span=\"1\">\n    <div data-field-span=\"1\">\n      <a href=\"#\" class=\"add-answer-explanation\">Add answer explanation?</a>\n      <div class=\"answer-explanation-container\" style=\"display: none\">\n        <label class=\"grid-form-label\">Answer explanation</label>\n        ";
output += runtime.suppressValue((lineno = 29, colno = 22, runtime.callWrap(runtime.memberLookup((t_1),"richtext"), "form[\"richtext\"]", context, ["wrong_answer_tip",{},{"nowrap": true,"placeholder": "Explain the correct answer (optional)...","bind": "model:wrong_answer_tip","style": "display: none","class": "full-width"}])), env.opts.autoescape);
output += "\n      </div>\n    </div>\n  </div>\n</div>\n";
output += runtime.suppressValue((lineno = 37, colno = 19, runtime.callWrap(runtime.memberLookup((t_1),"flash_message"), "form[\"flash_message\"]", context, [])), env.opts.autoescape);
output += "\n\n<div class=\"save-question-bar\">\n  <button\n    type=\"submit\"\n    class=\"save-question ButtonLegacy medium rounded primary interactive pw-form-submit\"\n  >\n    Save\n  </button>\n  or <a href=\"javascript:void(0);\" class=\"cancel\">cancel</a>\n</div>\n<div class=\"question-disable-overlay\"></div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

            })();
        

        function nunjucksTemplate(ctx = {}) {
            const templateContext = {
                __nunjucks_loader_assets__: __nunjucks_module_dependencies__.assets,
                ...ctx
            };

            var nunjucks = (runtime && runtime.default || runtime)(
                {"dev":false,"jinjaCompat":false,"isAsyncTemplate":false},
                __nunjucks_module_dependencies__
            );

            if (nunjucks.isAsync()) {
                return nunjucks.renderAsync(
                    "assessments/admin/views/templates/multiple-choice-question.html",
                    templateContext
                );
            }
        
            return nunjucks.render(
                "assessments/admin/views/templates/multiple-choice-question.html",
                templateContext
            );
        };

        nunjucksTemplate.__nunjucks_precompiled_template__ = __nunjucks_module_dependencies__.templates["assessments/admin/views/templates/multiple-choice-question.html"];
        nunjucksTemplate.__nunjucks_module_dependencies__ = __nunjucks_module_dependencies__;

        exports = module.exports = nunjucksTemplate;
    